import { useAnalytics } from "../../packages/analytics/analytics.ts"
import { useForm } from "../../packages/use-form.ts"
import { Routes } from "../check-in/ui/link.tsx"

export type LogoutButtonProps = {
  formClassName?: string
  buttonClassName?: string
}

export const LogoutButton = ({ formClassName, buttonClassName }: LogoutButtonProps) => {
  const { Form } = useForm()
  const analytics = useAnalytics()

  const handleSubmit = () => {
    analytics.reset()
  }

  return (
    <Form method="post" action={Routes.logout} className={formClassName} onSubmit={handleSubmit}>
      <button type="submit" className={buttonClassName}>
        로그아웃
      </button>
    </Form>
  )
}
